/* eslint-disable prefer-template */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
/* eslint-disable no-console */
/* eslint-disable prefer-const */
/* eslint-disable react/button-has-type */
/* eslint-disable react/self-closing-comp */
/* eslint-disable new-cap */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-await-in-loop */
/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect, useRef } from 'react';
import { Redirect } from 'react-router-dom';
import { Row, Col, Container } from 'reactstrap';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import {
  Typography,
  Grid,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import '../../shared/arial';
import Loader from 'react-loader-spinner';
import MaterialTable from 'material-table';
import { makeStyles } from '@material-ui/core/styles';
import { CloudCircle } from '@material-ui/icons';
import { Loading, exportXlsx } from '../../helpers/utils';
import companyServices from '../../redux/services/companyServices';
import elearningDetailsServices from '../../redux/services/elearningDetailsServices';
import ScaleExams from './ScaleExams';
import examType5Services from '../../redux/services/examType5Services';
// import groupServices from '../../redux/services/groupServices';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    marginBottom: 20,
  },
  resultRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '10px',
  },
  gradeDetails: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  totalGrade: {
    // color: '#000000',
    fontSize: '13px',
    fontWeight: 'bold',
  },
  resultDetail: {
    // color: '#666666',
    fontSize: '13px',
  },
}));

const ExamResultsWithVideo = ({ examIdentifier, grpLvl1, examModalities }) => {
  const [loadingState, setLoadingState] = useState(false);
  const [substring, setSubstring] = useState(null);
  const [redirect, setRedirect] = useState(false);
  // const [examId, setExamId] = useState();
  const [exam, setExam] = useState();
  const [totalPapers, setTotalPapers] = useState(0);
  const [examModality, setExamModality] = useState({});
  const refTable = useRef();

  const [examData, setExamData] = useState([]);
  const classes = useStyles();

  const handleDownload = async (filename, studentName) => {
    const downloadedFile = await examType5Services.downloadVideoCapsule(filename);
    const response = await fetch(downloadedFile.url);
    const blob = await response.blob();

    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `${studentName}.mp4`;
    a.click();

    URL.revokeObjectURL(url);
  };

  const loadExamResults = async () => {
    setLoadingState(true);
    const companyRes = await companyServices.getCompanyBygroupId(grpLvl1);
    const examRes = await elearningDetailsServices.getElearningDetailWithStudents(examIdentifier);
    if (companyRes && examRes) {
      setExam(examRes.exam);
      const formatedArray = [];
      const examStudents = [];
      if (examRes.students) {
        let papers = 0;
        examRes.students.forEach((student) => {
          if (parseFloat(student.semester, 10) === parseFloat(examRes.exam.semester, 10)
              || parseFloat(student.semester, 10) - 1 === parseFloat(examRes.exam.semester, 10)
              || student.catchUp?.includes(parseFloat(examRes.exam.semester, 10))) {
            examStudents.push(student);
          }
        });
        await Promise.all(examStudents.map(async (student) => {
          // const name = `${student.firstname} ${student.name}`;
          const dataObj = {
            userId: student._id,
            firstname: student.firstname,
            name: student.name,
            teacherId: student.teacherId || 'No corrector assigned',
            file: 'file not sent',
            filename: null,
            uploaded_at: null,
            updated_at: null,
            comment: null,
            grade: null,
          };
          const resExamType5 = await examType5Services.getExamType5(student._id, examIdentifier);
          if (resExamType5 && resExamType5 !== null && !resExamType5.error) {
            dataObj.file = 'file sent';
            dataObj.filename = resExamType5.file;
            dataObj.uploaded_at = resExamType5.created_at;
            dataObj.updated_at = resExamType5.updated_at;
          }
          examRes.exam.results.forEach((result) => {
            if (result.userId === student._id) {
              if (result.grade) {
                dataObj.grade = result.grade;
                dataObj.teacherId = result.teacherId || 'No corrector assigned';
                const grades = Object.values(result.grade);
                const sum = grades.reduce((a, b) => a + b);
                if (sum > 0) papers += 1;
              }
              if (result.comment) {
                dataObj.comment = result.comment;
              }
            }
          });
          formatedArray.push(dataObj);
        }));
        setTotalPapers(papers);
      }
      setExamData(formatedArray);
      setLoadingState(false);
    }
  };

  useEffect(() => {
    examModalities.forEach((examModalityItem) => {
      if (examModalityItem.value === exam.modality) {
        setExamModality(examModalityItem);
      }
    });
  }, [exam]);

  useEffect(() => {
    loadExamResults();
  }, []);

  const handleRedirect = () => {
    setRedirect(true);
  };

  if (redirect) {
    return <Redirect to="/list" />;
  }
  return (
    <div className={classes.root}>
      <Container className="dashboard">
        <Row>
          <Col md={1} style={{ marginBottom: '20px' }}>
            <IconButton
              aria-label="delete"
              onClick={() => handleRedirect()}
            >
              <ArrowBackIcon />
            </IconButton>
          </Col>
        </Row>
      </Container>
      <Grid container spacing={2}>
        <Grid item xs={12} style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          {
            loadingState === false
              ? (
                <MaterialTable
                  style={{ width: '100%' }}
                  title={`Results for ${exam?.name ? exam.name.replace(/\b(level 1|level 2)\b\s*$/i, '') : ''} - Total papers: ${totalPapers}`}
                  columns={[
                    {
                      title: 'Corrector',
                      field: 'teacherId',
                      width: '5%',
                      render: (rowData) => {
                        if (rowData.teacherId && rowData.teacherId.firstname) {
                          return <Typography variant="caption">{`${rowData.teacherId.firstname} ${rowData.teacherId.name}`}</Typography>;
                        }
                        return <Typography variant="caption">No corrector assigned</Typography>;
                      },
                    },
                    {
                      title: 'Name',
                      field: 'name',
                      defaultSort: ' asc',
                    },
                    {
                      title: 'Firstname',
                      field: 'firstname',
                    },
                    {
                      title: 'Video sent',
                      field: 'file',
                      render: (rowData) => {
                        if (rowData.file === 'file sent') {
                          return (
                            <Tooltip title="Download video">
                              <IconButton
                                variant="filled"
                                color="primary"
                                onClick={() => handleDownload(rowData.filename, `${rowData.name}_${rowData.firstname}`)}
                              >
                                <CloudCircle />
                              </IconButton>
                            </Tooltip>
                          );
                        }
                        return (
                          <Typography variant="caption">
                            Video not sent
                          </Typography>
                        );
                      },
                    },
                    {
                      title: 'Grade',
                      field: 'results.grade',
                      width: '40%',
                      render: (rowData) => <ScaleExams rowData={rowData} examModality={examModality} />,
                    },
                    {
                      title: 'Comment',
                      field: 'results.comment',
                      render: ({ comment }) => {
                        if (comment !== null) {
                          return (
                            <Typography style={{ color: '#757575', fontSize: '13px' }}>
                              {comment}
                            </Typography>
                          );
                        }
                        return <Typography variant="caption" style={{ color: '#8f8f8f' }}>No comment</Typography>;
                      },
                    },
                  ]}
                  isLoading={loadingState}
                  components={{
                    OverlayLoading: () => (<Loading />),
                  }}
                  localization={{
                    body: {
                      emptyDataSourceMessage: loadingState ? '' : 'No results to display',
                    },
                  }}
                  tableRef={refTable}
                  data={examData}
                  options={{
                    search: true,
                    exportButton: {
                      csv: true,
                      pdf: false,
                    },
                    exportCsv: () => {
                      const examObj = { ...exam } || null;
                      const finalResults = [];
                      const resultsArr = [...examData];
                      resultsArr.sort((a, b) => a.name > b.name);
                      resultsArr.forEach((elem) => {
                        const item = {};
                        if (exam.anonymous) {
                          item['Numéro'] = elem.number;
                        } else {
                          item.Nom = elem.name;
                          item['Prénom'] = elem.firstname;
                        }
                        // searching for grade since it's not in the base obj of the student
                        exam?.results?.forEach((result) => {
                          if (result.userId === elem.userId && result.grade !== undefined) {
                            const gradeArr = Object.values(elem.grade);
                            const totalGrade = gradeArr.reduce((a, b) => a + b);
                            let total = 0;
                            examModality.grades.forEach((gradeItem) => {
                              item[gradeItem.gradeFr] = elem.grade[gradeItem.gradeEn];
                              total += gradeItem.value;
                            });
                            if (total === 20) {
                              item['Note (/20'] = totalGrade;
                            } else {
                              item['Score (/' + total + ')'] = totalGrade;
                              item['Note (/20'] = (totalGrade / total) * 20;
                            }
                          }
                        });
                        if (elem.grade === undefined) {
                          item.grade = 'n/a';
                        }
                        if (exam && exam !== null) {
                          exam.results.forEach((result) => {
                            if (result.userId === item.userId) {
                              item.Commentaire = result.comment;
                            }
                          });
                        }
                        finalResults.push(item);
                      });
                      const today = new Date();
                      const sortedArr = finalResults.sort((a, b) => ((
                        a.Nom > b.Nom)
                        ? 1
                        : ((b.Nom > a.Nom)
                          ? -1
                          : 0)
                      ));
                      exportXlsx(sortedArr, `${examObj.name.replace(/\b(level 1|level 2)\b\s*$/i, '')}_${today.getDate()}/${today.getMonth() + 1}`);
                    },
                    exportAllData: true,
                    pageSize: examData.length,
                    sorting: true,
                    tableLayout: 'auto',
                  }}
                  onRowClick={(e, data) => {
                    if (substring !== data.userId) {
                      setSubstring(data.userId);
                    } else {
                      setSubstring(null);
                    }
                  }}
                />
              )
              : <Loader type="TailSpin" color="#3F51B5" height={40} width={40} />
          }
        </Grid>
      </Grid>
    </div>
  );
};

export default ExamResultsWithVideo;
